function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 144.175,
    height: 37.54,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2068.8 538.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1192.59,
    y1: 1096.03,
    x2: 1128.51,
    y2: 761.16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2068.8 180.76v177.11c0 99.5-92.87 180.8-206.49 180.8H206.49c-88.88 0-165.18-49.75-194.12-119.32C4.44 400.24 0 379.53 0 357.87V180.76C0 81.29 92.86 0 206.49 0h1655.82c49.23 0 94.96 15.44 130.43 40.75 46.43 33.4 76.06 83.84 76.06 140.01z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.53 168.02v164.21c0 92.22-88.61 167.58-197.03 167.58H244.3c-84.83 0-157.64-46.1-185.24-110.59-7.59-17.73-11.82-36.94-11.82-56.99V168.02C47.24 75.8 135.88.44 244.3.44h1580.2c46.98 0 90.62 14.31 124.47 37.79 44.3 30.95 72.57 77.71 72.57 129.79z",
    style: {
      fill: "#8eca37",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.64 425.31c-618.11 7.46-993.51-5.55-1043.38-206.27-4.24-15.79-6.25-32.85-6.03-51.02C47.23 75.8 135.87.44 244.29.44h1580.2c46.98 0 90.62 14.31 124.47 37.79 7.79 17.94 12.02 37.15 12.02 57.22 81.72 402.44-404.13 324.31-864.35 329.86z",
    style: {
      fill: "#a9e02f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.66.44c-4.24 54.01-32.74 106.1-90.4 140.7-140.05 83.9-346.67 113.15-507.43 141.98-188.37 33.94-381.64 48.25-573.57 46.74-153.64-1.05-325.52-3.41-471.61-55.27-32.26-11.55-67.23-30.77-96.39-55.54-4.24-15.79-6.25-32.85-6.03-51.02C47.23 75.81 135.87.45 244.29.45h1548.37z",
    style: {
      fill: "#bff233",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.75 63.48-.02-.02c-35.05-33.62-97.45 12.87-116.54 31.82-35.13 34.86-47.09 90.06-42.4 142.42.98 10.65 33.89 28.91 47.73-18.42 29.71-101.92 97.95-98.54 116.38-127.17 5.63-8.73 3.69-20.13-5.16-28.62z",
    style: {
      fill: "#f7ffae",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonWide);
export default __webpack_public_path__ + "static/media/button_wide.a2563b62ff87caa640c468080faf3de4.svg";
export { ForwardRef as ReactComponent };